import React, { useState } from "react";
import {
  GridColumnMenuItemGroup,
  GridColumnMenuItemContent,
} from "@progress/kendo-react-grid";

export const CustomColumnSelector = (props) => {
  const [columns, setColumns] = useState(props.columns);

  const onToggleColumn = (id) => {
    const newColumns = columns.map((column, idx) => {
      return column.srNo === id ? { ...column, show: !column.show } : column;
    });
    setColumns(newColumns);
  };

  const onReset = (event) => {
    event?.preventDefault?.();
    const newColumns = props.columns.map((col) => {
      return { ...col, show: true };
    });
    setColumns(newColumns);
    props.onColumnsSubmit(newColumns, "reset");

    props?.onCloseMenu?.();
  };

  const onSubmit = (event) => {
    event?.preventDefault?.();
    props.onColumnsSubmit(columns, "submit");
    props?.onCloseMenu?.();
  };

  const oneVisibleColumn = columns.filter((c) => c.show).length === 1;

  const isRequired = (col) => columns.find((c) => col.key === c.key).isRequired;

  return (
    <div>
      <GridColumnMenuItemGroup>
        <GridColumnMenuItemContent show={true}>
          <div className={"k-column-list-wrapper"}>
            <form onSubmit={onSubmit} onReset={onReset}>
              <div className={"k-column-list"}>
                {columns
                  .filter((item) => item.isExportable)
                  .map((column, idx) => (
                    <div key={idx} className={"k-column-list-item"}>
                      <span>
                        <input
                          onClick={() => {
                            onToggleColumn(column.srNo);
                          }}
                          data-testid="input"
                          id={`column-visiblity-show-${idx}`}
                          className="k-checkbox"
                          type="checkbox"
                          readOnly={true}
                          disabled={
                            (column.show && oneVisibleColumn) ||
                            isRequired(column)
                          }
                          checked={column.show}
                        />
                        <label
                          htmlFor={`column-visiblity-show-${idx}`}
                          className="k-checkbox-label"
                          style={{
                            userSelect: "none",
                          }}
                        >
                          {column.title}
                        </label>
                      </span>
                    </div>
                  ))}
              </div>
              <div className={"k-actions k-hstack k-justify-content-stretch"}>
                <button type={"reset"} className={"k-button"}>
                  Reset
                </button>
                <button className={"k-button k-primary"}>Save</button>
              </div>
            </form>
          </div>
        </GridColumnMenuItemContent>
      </GridColumnMenuItemGroup>
    </div>
  );
};
export default CustomColumnSelector;
